import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of drills copied from the internet.', 'This is not a theoretical manual you need to rewrite before it works in a real lesson.', 'This is not content designed for a different type of instructor that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-brand relative overflow-hidden" data-id="element-183" data-mp="z2fsotxpw50n">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-184" data-mp="u2tcqcqi8ao5" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-185" data-mp="183m6gv8zf1q7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-186" data-mp="13zxzoes6ca60">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-cream/10 border border-gold/50 text-gold mb-5" data-id="element-187" data-mp="2jg6kyd1qmiuj">
            <span className="text-2xl" aria-hidden="true" data-id="element-188" data-mp="2fhpd1raht4c2">
              🏆
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-cream" data-id="element-189" data-mp="2by1rmqo22hak">
            The Most Complete Golf Teaching Library for Instructors Worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold mb-3" data-id="element-190" data-mp="2kx6prvvpg8m7">Golf Instructor Ready — A Complete 6-in-1 Teaching System</h3>
          <p className="text-base md:text-lg text-cream/80 mb-10" data-id="element-191" data-mp="2pt45q1323cyg">
            100 Ready-to-Teach Lessons · 5 Strategic Bonuses · Everything ready to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-192" data-mp="1x4gfdr3g9xe1">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-cream p-6 rounded-2xl border border-mist" data-id="element-193" data-mp="22548cib8ooaw">
            {negatives.map(item => <div key={item} className="flex items-start gap-3" data-id="element-194" data-mp="1ef9vi0qx6zqn">
                <X className="text-red-700 shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-195" data-mp="2hqz2daqbyzco" />
                <p className="text-ink/70 text-sm" data-id="element-196" data-mp="2cs5ovib1n8ci">{item}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-ivory p-6 rounded-2xl border-2 border-gold relative overflow-hidden" data-id="element-197" data-mp="2qk2cpa5oiw33">
            <div className="flex items-start gap-3 relative z-10" data-id="element-198" data-mp="1yuh2u758pv5v">
              <Check className="text-forest shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-199" data-mp="1tubg95dtuyun" />
              <p className="text-brand font-medium text-base leading-relaxed" data-id="element-200" data-mp="27u45sxdmb911">
                This is a complete 6-in-1 professional teaching system — so you arrive at every lesson fully prepared,
                confident, and ready to deliver a session your students will genuinely feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}